import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import { Close, ManageAccounts } from '@mui/icons-material';
import { AdminAction } from '../../components/admin';

function DetailField({ label, value }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          mb: 0.5,
          color: '#78716c',
          fontWeight: 700,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
        }}
      >
        {label}
      </Typography>
      <Typography variant="body2" sx={{ color: '#1c1917', fontWeight: 600 }}>
        {value || '—'}
      </Typography>
    </Box>
  );
}

function formatDateTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export default function AdminUserViewDialog({ user, open, onClose, onEdit }) {
  if (!user) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '14px',
          boxShadow: '0 24px 64px rgba(0,0,0,0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          background: 'linear-gradient(135deg, #182414, #2a3d1e)',
          color: '#ecf3e7',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          py: 2,
          px: 3,
        }}
      >
        <ManageAccounts sx={{ color: '#9bd53d' }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#fff' }} noWrap>
            {user.fullName}
          </Typography>
          <Typography variant="caption" sx={{ color: '#8ab87b' }}>
            @{user.username}
          </Typography>
        </Box>
        <Chip
          label={user.status}
          size="small"
          sx={{
            background: user.status === 'Active' ? 'rgba(155,213,61,0.2)' : 'rgba(197,84,61,0.2)',
            color: user.status === 'Active' ? '#9bd53d' : '#f4917e',
            fontWeight: 700,
            border: `1px solid ${user.status === 'Active' ? '#9bd53d' : '#f4917e'}`,
          }}
        />
        <IconButton onClick={onClose} sx={{ color: '#ecf3e7', ml: 1 }} size="small">
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3, pt: 3, pb: 1 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '0 24px' }}>
          <DetailField label="Full Name" value={user.fullName} />
          <DetailField label="Username" value={`@${user.username}`} />
          <DetailField label="Email Address" value={user.email} />
          <DetailField label="Role" value={user.role} />
          <DetailField label="Status" value={user.status} />
          <DetailField label="Last Login" value={formatDateTime(user.lastLoginAt)} />
          <DetailField label="Created Date" value={formatDate(user.createdAt)} />
          <DetailField label="Last Updated" value={formatDate(user.updatedAt)} />
        </Box>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <AdminAction onClick={onClose} variant="outline">
          Close
        </AdminAction>
        <AdminAction onClick={() => onEdit(user)}>
          Edit User
        </AdminAction>
      </DialogActions>
    </Dialog>
  );
}
